module.exports = {
    localMediaTitle: "本地媒体营销",
    sumOfToday:'今日总和',
    cost:'花费',
    performanceOverview:'数据概览',
    basicInformation:'基本信息',
    dataView:'维度数据',
    trackingStatistics:'统计数据',
    filters:'筛选',
    timeIntervel:'时间分组',
    dateRange:'时间区间',
    deleteCheckedItem: '删除已选项',
    performanceOverviewHelp: '由于APP推广地区的时区不同，该模块的统计数据可能与您的平台不同。各时区的详细数据可以在该模块的明细报表模块中查询。',
    dashboard:'大盘分析',
    installs:'安装',
    report:'明细报告',
    ok:'保存',
    campain:'产品',
    eventMethod:'事件方法',
    source:'三方平台:',
    apptoken:'app密钥:',
    currency:'货币类型:',
    apitoken:'api密钥:',
    eventName:'事件名称',
    creatives:'广告素材',
    selectsname:'按产品名称搜索',
    site_id:'广告系列',
    timedate:'时间:',
    Event:'事件',
    analysis: '分析报告',
    inapp:'应用内事件',
    setting:'设置',
    basicData: '基础数据',
    psd:'请选择日期',
    psp:'请选择产品',
    media:'请选择媒体资源',
    ecd:'编辑',
    pif:'请选择格式',
    uploadCreatives: '上传广告素材',
    appName: '应用产品名称',
    mediasource: '媒体资源',
    click: '点击',
    click_count:'点击',
    sorts:'排序方式',
    install_count: '安装',
    conversion: '转化',
    retargeting: '再营销',
    impression: '展示',
    cost: '花费',
    revenue: '收入',
    cr: '点击转化率',
    imp_count:'展示',
    ivr: '展示转化率',
    ctr: '点击率',
    pay: 'Pay',
    payRate: 'Pay Rate',
    login: 'Login',
    loginRate: 'Login Rate',
    retention: '留存',
    retentionRate: 'Retention Rate',
    purchase: 'Purchase',
    arpu: 'ARPU',
    roi:'投资回报率',
    filterByProducts: '按产品过滤',
    filterByFormat: '按格式过滤',
    selectMonth: '选择月',
    imageCreatives: '图片素材',
    videoCreatives: '视频素材',
    amount: '总数',
    install: '安装量',
    allReport: '所有报告',
    Weekly: '周报',
    Monthly: '月报',
    qbr: 'QBR',
    QBR:'QBR',
    others: '其他',
    dataRange:'时间范围',
    preprice$:'预约价格(美元)',
    Others: '其他',
    advertiser: '广告主',
    country: '国家',
    kpi: '核心指标',
    enterAdvertiser: '请输入广告主名称',
    enterAppname: '请输入应用产品名称',
    enterMediaSource: '请输入媒体资源名称',
    enterCountry: '请输入国家名称',
    enterSiteid:'请输入广告系列',
    Install:'安装',
    CTR:'点击率',
    CVR:'转化率',
    cvr:'转化率',
    IMP:'展示',
    Click:'点击',
    Sortby:'排序',
    All:'全部',
    Image:'图片',
    Video:'视频',
    pkg:'包名:',
    agency:'代理名称:',
    kpirule:'核心指标规则',


    costSetting:'成本设置',
    reportid:'报告序号',
    rules:'规则',
    	
    operate:'操作',
    price$:'价格(美元)',
    placeholder:'广告主查询',
    kindTip:'温馨提示：',
    tipsCont:'如果您不需要更改，请不要填写任何有创意的内容。我们将批量更新您检查的创意。',
    timerange:'时间范围:',
    product:'产品:',
    products:'产品',
    format:'规格:',
    Format:'规格',
    Export:'导出',
    items:'条数据：',
    most20:'选择事件个数最多为20个！',
    selectf:'请选择规格',
    selectp:'请选择产品',
    selecta:"请选择时间",
    customEvent:'自定义事件',
    removeall:'全部移除',
    item:'项',
    Benchmark:'业绩基准值',
    Expand:'收缩',
    Collapse:'展开',
    EditFailed:'编辑失败',
    mustNumber:'必须为纯数字',
    mustint:'Event unique users/Event count值必须为整数',
    mustfloat:'Event conversion/Event ratio值必须为数字类型，且保留两位小数',

    liftAdvertising: '电梯媒体',
    campaignSetting: '媒体设置',
    sumOfYesterdayCost: '昨天花费',
    settingBasicData: '基础数据',
    settingCreatives:'广告素材',
    settingAnalysis: '分析报告',
    conversionType: '转化类型',
}



// WEBPACK FOOTER //
// ./src/i18n/modules/localMedia/zh-cn.js